import React from 'react';
import { MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MoreOptionsButton } from '../../Common/MoreOptionsButton';
import EditIcon from '../../../icons/EditIcon';
import DeleteIcon from '../../../icons/DeleteIcon';

interface Props {
  onEditPriceClass: () => void;
  onDeleteBonusCode: () => void;
}

const BonusCodesTableDropdown = ({
  onEditPriceClass,
  onDeleteBonusCode,
}: Props) => {
  const { t } = useTranslation();

  return (
    <MoreOptionsButton>
      <MenuItem key={0} onClick={onEditPriceClass}>
        <EditIcon />
        {t('settings.bonusCodes.buttons.edit')}
      </MenuItem>
      <MenuItem key={1} onClick={onDeleteBonusCode}>
        <DeleteIcon />
        {t('settings.bonusCodes.buttons.delete')}
      </MenuItem>
    </MoreOptionsButton>
  );
};

export default BonusCodesTableDropdown;
